export const strings = {
  english: {
    title: 'Lost your password?',
    hero: 'Please enter your email address. You will receive a link to create a new password via email.',
    label: 'Email',
    button: 'RESET PASSWORD',
    back: 'Back to login',
  },

  japan: {
    title: 'パスワードを忘れましたか？',
    hero: 'メールアドレスを入力してください。新しいパスワードを作成するためのリンクがメールで届きます。',
    label: 'メールアドレス',
    button: 'パスワードを再設定する',
    back: 'ログインに戻る',
  },
};
